import styled, { StyledComponent } from "styled-components";

export const LiteTradePortfolioStyled = styled.div`
`;
export const LiteTradePortfolioTitleStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 12px;
    align-items: center;

    h6 {
        font-weight: 600;
        color: var(--color-label-secondary);
    }
`;
export const LiteTradePortfolioSumPlStyled = styled.div`
    font-weight: 600;
    font-size: 16px;
    
    background: var(--color-button-secondary-default);
    border-radius: 12px;
    padding: 4px 12px;
    color: var(--color-label-secondary);
    
    display: flex;
    align-items: center;
    gap: 4px;
`;
export const LiteTradePortfolioListStyled = styled.div`
    background: var(--color-background-secondary);
    border-radius: 16px;
    margin-bottom: 24px;
    box-shadow: var(--shadow-primary);

`;

export const LiteTradePortfolioListItemWrapperStyled = styled.div`
    padding: 0 16px;

    > * {
        border-bottom: 1px solid var(--color-divider-transparent);
    }

    &:last-child {
        > * {
            border-bottom: none;
        }
    }
`;

interface ILiteTradePortfolioItemProgressStyledProps extends React.ComponentProps<StyledComponent<"div", any, {}, never>> {
    progress: number,
}
export const LiteTradePortfolioItemProgressStyled = styled.div<ILiteTradePortfolioItemProgressStyledProps>`
    width: 100%;
    height: 4px;
    background: var(--color-fill-secondary);
    border-radius: 2px;
    position: relative;

    &:after {
        position: absolute;
        top: 0;
        left: 0;
        width: ${({ progress }) => (`${progress || 1}%`)};
        height: 4px;
        content: '';
        display: block;
        background: var(--color-label-accent);
        border-radius: 2px;
    }
`;

export const LiteTradePortfolioListItemStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    max-width: 100%;

    > * {
        padding: 16px 0;
    }


    .col-left {
        font-size: 28px;
        display: flex;
        align-items: center;
    }

    .col-center {
        flex: 1;
        overflow: hidden;

        * {
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .col-right {
        text-align: right;
        flex-shrink: 0;
        color: var(--color-label-primary);
    }

    .protection {
        display: inline-flex;
        gap: 2px;
        color: var(--color-label-secondary);

        > span {
            background: var(--color-fill-secondary);
            border-radius: 4px;
            padding: 0 4px;
        }
    }

    * {
        white-space: nowrap;
    }

    &.inactive {
        .col-left {
            opacity: 0.5;
        }

        .col-center {
            color: var(--color-white-60);
        }

        .col-right {
            opacity: 0.6;
        }

        .asset-row-info {
            opacity: 0.6;
        }

        .progress {
            &:after {
                background: rgba(129, 146, 228, 0.2);
            }
        }
    }
`;

export const LiteTradePortfolioListItemLoaderStyled = styled.div`
    width: 24px;
`;

interface ILiteTradePortfolioPositionPlAnimationContentStyledProps {
    color?: string,
    animationType: string,
    animationDurationMs: number,
    textShadow?: string,
    plSizeMultiplier?: number,
}

export const LiteTradePortfolioPositionPlAnimationContentStyled = styled.div<ILiteTradePortfolioPositionPlAnimationContentStyledProps>`
    ${({ textShadow }) => textShadow ? `text-shadow: ${textShadow};` : ''}
    font-weight: 600;
    color: ${({ color }) => color || 'var(--color-label-primary)'};
    transform: scale(${({ plSizeMultiplier }) => plSizeMultiplier || 1});

    &.animation-running {
        ${({ animationType, animationDurationMs }) => `transition: all ${animationDurationMs}ms ${animationType};`}
    }
`;

export const LiteTradePortfolioPositionPlAnimationContainerStyled = styled.div`
    position: absolute;
    bottom: 0;
    right: -26px;
    
    > div {
        height: 40px;
        width: 40px;
    }
    
    .animation {
        top: 0;
        left: 0;
        position: absolute;
        height: 100%;
        width: auto;
    }
`;
